import React from "react";
import { Link } from "react-router-dom";
import { blogPosts } from "../../data/blogData";

const BlogList = () => {
  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Music Creation Resources
          </h2>
          <div className="w-24 h-1 bg-purple-600 mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Learn, grow, and master the art of creating your own original music
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {blogPosts.map((blog, index) => (
            <div 
              key={index}
              className="bg-gray-50 rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all transform hover:-translate-y-2"
            >
              <div className="h-48 bg-gradient-to-br from-purple-500 to-pink-500"></div>
              <div className="p-6">
                <div className="flex items-center justify-between mb-3">
                  <span className="text-purple-600 font-semibold text-sm">
                    {blog.category}
                  </span>
                  <span className="text-gray-500 text-sm">{blog.date}</span>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {blog.title}
                </h3>
                <p className="text-gray-600 mb-4">
                  {blog.excerpt}
                </p>
                <Link 
                  to={`/blog/${blog.slug}`}
                  className="text-purple-600 font-semibold hover:text-purple-700 transition-colors"
                >
                  Read More →
                </Link>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <a 
            href="/zoom"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-purple-900 hover:bg-purple-800 text-white font-bold py-3 px-8 rounded-lg transition-all transform hover:scale-105 inline-block"
          >
            👉 Start Your Music Journey
          </a>
        </div>
      </div>
    </section>
  );
};

export default BlogList;
